import React from 'react';
import { CommonIconProps } from './Icon';

const PieChartIcon = ({ color }: CommonIconProps): JSX.Element => (
  <>
    <g clipPath="url(#clip0_32_781)">
      <path
        d="M10.5 24C13.284 23.9974 15.9531 22.8903 17.9217 20.9217C19.8903 18.9531 20.9974 16.284 21 13.5C21 13.3674 20.9473 13.2402 20.8536 13.1464C20.7598 13.0527 20.6326 13 20.5 13H11.5C11.3674 13 11.2402 12.9473 11.1464 12.8536C11.0527 12.7598 11 12.6326 11 12.5V3.5C11 3.36739 10.9473 3.24021 10.8536 3.14645C10.7598 3.05268 10.6326 3 10.5 3C7.71523 3 5.04451 4.10625 3.07538 6.07538C1.10625 8.04451 0 10.7152 0 13.5C0 16.2848 1.10625 18.9555 3.07538 20.9246C5.04451 22.8938 7.71523 24 10.5 24Z"
        fill={color}
      />
      <path
        d="M13.5 0C13.3674 0 13.2402 0.0526784 13.1464 0.146447C13.0527 0.240215 13 0.367392 13 0.5V10C13 10.2652 13.1054 10.5196 13.2929 10.7071C13.4804 10.8946 13.7348 11 14 11H23.5C23.6326 11 23.7598 10.9473 23.8536 10.8536C23.9473 10.7598 24 10.6326 24 10.5C23.9974 7.71604 22.8903 5.04686 20.9217 3.0783C18.9531 1.10974 16.284 0.00264761 13.5 0V0Z"
        fill={color}
      />
    </g>
  </>
);

export default PieChartIcon;
